import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import classnames from 'classnames';
import { DropTarget } from 'react-dnd';
import {
  NavLink,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { getSidebarCurrentRoute, isArchive } from '../../helpers/App';
import { userHasCap } from '../../helpers/Auth';
import { collectionsTarget } from '../../helpers/DNDCollections';
import ItemTypes from '../../helpers/DNDItemTypes';
import { getSetting } from '../../helpers/Settings';
import { getCurrentURLParams } from '../../helpers/URLParams';

const SidebarAllCollections = ({
  connectDropTarget,
  isOver,
  canDrop,
  handleOpenNewCollectionModal,
  location,
}) => {
  const intl = useIntl();

  return (connectDropTarget(
    <div
      className={classnames(
        'nav-item',
        'nav-item-collections',
        {
          hovered: isOver && canDrop,
          active: getSidebarCurrentRoute(location) === 'collections',
        },
      )}
    >
      <NavLink
        tag={Link}
        to={`${isArchive() ? '/archive' : ''}/collections${window.location.pathname === '/collections' || window.location.pathname === '/archive' ? getCurrentURLParams(location) : ''}`}
      >
        <i className="far fa-layer-group" />
        {getSetting('cs1') ? (
          intl.formatMessage({ defaultMessage: 'Browse Categories' })
        ) : (
          intl.formatMessage({ defaultMessage: 'All Collections' })
        )}
      </NavLink>
      {userHasCap('create_collection_all') && (
        <>
          <a href="#add" id="create-new-collection" onClick={handleOpenNewCollectionModal} aria-label={intl.formatMessage({ defaultMessage: 'New Collection' })}>
            <i className="far fa-plus" />
          </a>
          <UncontrolledTooltip target="create-new-collection" fade={false}>
            {intl.formatMessage({ defaultMessage: 'New Collection' })}
          </UncontrolledTooltip>
        </>
      )}
    </div>,
  ));
};

SidebarAllCollections.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  handleOpenNewCollectionModal: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
};

export default
withRouter((DropTarget(ItemTypes.COLLECTION, collectionsTarget, (DNDconnect, monitor) => ({
  connectDropTarget: DNDconnect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
}))(SidebarAllCollections)));
